/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type AccountNav_viewer = {| |};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AccountNav_viewer",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "AccountNavContent_viewer",
      "args": null
    }
  ],
  "type": "Viewer"
};

module.exports = fragment;
